<template>
    <HeaderNav ref="refLogin" />
    <div>
        <!-- <div class="trends">
      <p style="font-size: 46px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">产品商城</p>
      <p style="font-size: 20px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #FFFFFF;">公司制衣分类</p>
    </div> -->
        <div class="back" @click="back">&lt;&nbsp;{{ $t('meg.back') }}</div>
        <div class="detailsBox">
            <div class="imgBox">
                <img :src="detailsData.productImg" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="main_detail" style="margin-left: .675rem;width: 50%;">
                <h1
                    style="font-size: .25rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: bold;color: #333333;text-align: left;">
                    {{ detailsData.productName }}</h1>
                <p
                    style="font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #777777;text-align: left;margin-top: .125rem">
                    服装-{{ detailsData.productType }}</p>
                <p
                    style="font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #777777;text-align: left;margin-top: .125rem">
                    {{ detailsData.clothingSeason }}</p>
                <p
                    style=" font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 700;color: #333333;text-align: left;margin-top: .3125rem;">
                    {{ $t('meg.surface') }}:{{ detailsData.productExplain }}</p>
                <p
                    style="margin-top: .3125rem; text-align: left; font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;color: #333333;font-weight: 700;">
                    {{ $t('meg.specialProcess') }}:{{ detailsData.specialTechnique }}
                </p>
                <hr
                    style="margin-top: .425rem;width: 5.8625rem;height: 0rem;opacity: 1;border: .0125rem solid #DDDDDD;">
                <!-- <div style="margin-top: 34px; text-align: left; font-size: 16px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">
                ￥{{ detailsData.productPrice }}
            </div> -->
                <p
                    style="margin-bottom: .125rem;margin-top:.2rem;text-align: left;font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #777777;">
                    {{ $t('meg.color') }}</p>
                <div style="display: flex;">
                    <el-button class="Btn" v-for="item in colorBox" :key="item">{{ item }}</el-button>
                </div>
                <p
                    style="margin-bottom: .125rem;margin-top: .2rem;text-align: left;font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #777777;">
                    {{ $t('meg.size') }}</p>
                <div style="display: flex;">
                    <el-button class="Btn" v-for="item in sizeBox" :key="item.value">{{ item.label }}</el-button>
                </div>
                <div style="text-align: left;margin-top: .675rem;display: flex;">
                    <el-button class="collectBtn" @click="collect">{{ colletStr == 1 ? "取消收藏" : "收藏" }}</el-button>
                    <el-button class="orderBtn" @click="orderpush">{{ $t('meg.order') }}</el-button>
                </div>
            </div>
        </div>
        <div class="derails_img">
            <h1
                style="font-size: .25rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">
                商品详情</h1>
            <div style="margin-top: .65rem;">
                <img :src="citem.url" alt="" style="width: 100%;" v-for="citem in detailsData.pictures" :key="citem">
            </div>
        </div>
    </div>
    <Footer />
</template>

<script setup>
import HeaderNav from "../../../components/nav/headerNav.vue";
import Footer from "../../../components/nav/footerNav.vue";
import { onMounted, ref, nextTick } from 'vue';
import { productDetails, productCollect } from "@/api/home.js"
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus'
import { getDicts, selectIsInfo } from "@/api/order.js"
const colletStr = ref("")
const router = useRouter()
const sizeBox = ref([])
const colorBox = ref([])
const route = useRoute();
const refLogin = ref()
const access_token = localStorage.getItem("access_token")

const productId = ref("")
const detailsData = ref({})
onMounted(() => {
    productId.value = route.query.productId
    getDetails(productId.value)
   
    getDicts("goods_color").then(res => {
        res.data.data.map((item, index) => {
            if (item.dictValue == detailsData.value.productColour) {
                detailsData.value.productColour = item.dictLabel
            }

        })
    })
    getDicts("clothing_season").then(res => {
        res.data.data.map((item, index) => {
            if (item.dictValue == detailsData.value.clothingSeason) {
                detailsData.value.clothingSeason = item.dictLabel
            }
        })
    })
})

const orderpush = () => {
    if (access_token) {
        selectIsInfo().then(res => {
            if (res.data.code == 200) {
                router.push({ path: "/placeOrder", query: { productId: productId.value } })
            } else {
                ElMessage.error(res.data.msg)
            }
        })
    } else {
        ElMessage.error("您还未登录，请先登录")
        if (refLogin.value) {
            refLogin.value.openModal(); // 通过引用调用子组件的方法
        }
    }
}

const collect = () => {
    if (access_token) {
        productCollect({ productId: productId.value }).then(res => {
            if (res.data.code == 200) {
                colletStr.value = res.data.data
                ElMessage.success(res.data.msg)
            }
        })
    } else {
        ElMessage.error("您还未登录，请先登录")
        if (refLogin.value) {
            refLogin.value.openModal(); // 通过引用调用子组件的方法
        }
    }
}

const getDetails = (productId) => {
    productDetails(productId).then(res => {
        detailsData.value = res.data.data
        sizeBox.value = res.data.data.sizes
        colorBox.value = res.data.data.colours
        getDicts("product_type").then(res => {
        res.data.data.forEach((item, index) => {
            if (item.dictValue == detailsData.value.productType) {
                detailsData.value.productType = item.dictLabel
            }
        })
    })
    })
}


const back = () => {
    router.go(-1)
}

</script>

<style scoped>
.back {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: left;
    margin-left: .425rem;
    margin-top: 1.625rem;
    padding-left: 4.125rem;
    cursor: pointer;
}

.trends {
    height: 3.5rem;
    background: url("../../../assets/img/news_bg.png") no-repeat;
    background-size: 100% 100%;
    text-align: left;
    padding-left: 4.5rem;
    padding-top: 1.175rem;
}

.detailsBox {
    margin: .625rem 4.5rem;
    /* background: pink; */
    display: flex;
}

.derails_img {
    margin: 0rem 4.5rem;
}

.imgBox {
    /* width: 4.825rem; */
    height: 4.825rem;
}

.priceBox {
    height: 1.1rem;
    line-height: 1.1rem;
    padding-left: .225rem;
    text-align: left;
    background: #F1F1F1;
    font-size: .425rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #DD1111;
}

.Btn {
    width: 1.2rem;
    height: .45rem;
    background: #FFFFFF;
    opacity: 1;
    border: .0125rem solid #DDDDDD;
    font-size: .2rem;
}

.collectBtn {
    width: 2.8625rem;
    height: .5875rem;
    background: #F7B02D;
    opacity: 1;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
}

.orderBtn {
    width: 2.85rem;
    height: .5875rem;
    background: #002FA7;
    opacity: 1;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
}
</style>
